import { FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

export const ContinueShopping = (
  <FormattedMessage {...commonMessages.continueShopping} />
);
